export const FOOTBALL_LIVE_POLL_MS = 30_000

const LIVE_FOOTBALL_STATUSES = new Set([
  '1H',
  'HT',
  '2H',
  'ET',
  'BT',
  'P',
  'LIVE',
  'INT',
  'SUSP',
])

export type FootballLiveMatchLike = {
  score?: string | null
  liveScore?: string | null
  liveStatus?: string | null
}

export function isFootballMatchLive(match?: FootballLiveMatchLike | null): boolean {
  return LIVE_FOOTBALL_STATUSES.has(String(match?.liveStatus ?? '').toUpperCase())
}

export function footballDisplayScore(match?: FootballLiveMatchLike | null): string {
  if (!match) return ''
  const live = isFootballMatchLive(match)
  const raw = live && match.liveScore ? match.liveScore : match.score
  const score = raw != null ? String(raw).trim() : ''
  if (!score || score.toLowerCase() === 'null') return ''
  return score
}

export function footballLiveBadge(match?: FootballLiveMatchLike | null): string {
  if (!isFootballMatchLive(match)) return ''
  const st = String(match?.liveStatus ?? '').toUpperCase()
  if (!st || st === 'LIVE') return 'LIVE'
  return `LIVE ${st}`
}
